import { toQueryParam } from "../../../handlers/filter";
/**
 * @param filters: array of SDK-style advertisers filters.
 * @return: a proper query string for the supplied filters.
 */
const wheresToQueryParams = (filters) => {
    let params = "";
    if (filters.where) {
        for (const filter of filters.where) {
            switch (filter.field) {
                case "runsBetween": {
                    const value = toQueryParam(filter, { join: "|" });
                    params = `${params}&runsBetween=${value}`;
                    break;
                }
                case "campaignStatuses": {
                    const value = toQueryParam(filter);
                    params = `${params}&campaignStatuses=${value}`;
                    break;
                }
                case "id": {
                    const value = toQueryParam(filter);
                    params = `${params}&ids=${value}`;
                    break;
                }
            }
        }
    }
    return params;
};
/**
 * @param filters: array of SDK-style advertisers filters.
 * @param sort: optional. Information on the field and direction of sorting, if any.
 * @return: a proper query string for the supplied filters and sort.
 */
export const toQueryParams = (filters, sort) => {
    let params = wheresToQueryParams(filters);
    if (sort && sort.field && sort.direction) {
        params = `${params}&sortBy=${sort.field}%20${sort.direction}`;
    }
    if (params.length) {
        return `?${params}`;
    }
    return "";
};
//# sourceMappingURL=query.js.map